<script>
import { BModal, BFormDatepicker, BFormInput, BFormGroup } from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {required, email as emailValidation} from '@validations'

export default {
    components: {BModal, BFormInput, BFormDatepicker, BFormGroup, ValidationProvider, ValidationObserver},
    data() {
        return {
            date: null,
            email: null,
            required,
            emailValidation
        };
    },
    methods: {
        show() {
            this.$refs.modal.show();
        },
        save(e) {
            e.preventDefault();
            this.$refs.generalInfo.validate().then(valid => {
                if (!valid) {
                    return;
                }

                this.$emit('saved', {
                    date: this.date,
                    email: this.email,
                });

                this.$refs.modal.hide();
            });
        },
        populate(data) {
            this.date = data.date;
            this.email = data.email;
        }
    }
}
</script>

<template>
    <b-modal
        ref="modal"
        :ok-title="$t('Component(ExternalResponseModal):save-button')"
        :cancel-title="$t('Component(Button):cancel')"
        centered
        :title="$t('Component(ExternalResponseModal):title')"
        @ok="save"
    >
        <validation-observer ref="generalInfo">
            <b-form-group
                :label="$t('Component(ExternalResponseModal):date')"
                label-for="date"
            >
                <validation-provider
                    #default="{ errors }"
                    :name="$t('Component(ExternalResponseModal):date')"
                    rules="required"
                >
                    <b-form-datepicker
                        :state="errors.length > 0 ? false:null"
                        id="date"
                        v-model="date"
                        :placeholder="$t('Component(ExternalResponseModal):date')"
                        :date-format-options="$store.state.component.datePicker.format"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </b-form-group>
            <b-form-group
                :label="$t('Component(ExternalResponseModal):email')"
                label-for="email"
            >
                <validation-provider
                    #default="{ errors }"
                    :name="$t('Component(Label):email')"
                    rules="email"
                >
                    <b-form-input
                        :state="errors.length > 0 ? false:null"
                        id="email"
                        type="email"
                        v-model="email"
                        :placeholder="$t('Component(Label):email')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </b-form-group>
        </validation-observer>
    </b-modal>
</template>
